import React from 'react'
import Header from "../../../../Components/Header";
import Address from './Address'
import { Helmet } from 'react-helmet';
function ViewAddress() {
    return (
      <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Address List</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <Address />
      </div>
    </div>
    )
}

export default ViewAddress
